module.exports = __webpack_public_path__ + "img/5.3c6eb212.jpg";